import { CSSProperties, PropsWithChildren, useMemo, useRef, useState } from 'react';
import PreviewCardIddle from './Card';
import PreviewContext, { IActiveElement } from './context';
import PreviewCardActive from './Card/Active/index';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  portal: {
    position: 'absolute',
    zIndex: 10,
    transform: 'scale(0.9) translateY(-35%)',
    transition: 'transform 300ms',
  },
}));

const PreviewContainerCard = (props: PropsWithChildren<{}>) => {
  const [activeElement, setActiveElement] = useState<IActiveElement>({
    id: null,
    target: null,
  });
  const portalRef = useRef<HTMLDivElement>(null);
  const timeout = useRef<NodeJS.Timeout>(null);
  const classes = useStyles();

  const getStyles: CSSProperties = useMemo(() => {
    if (!activeElement.target) return null;
    const rect = activeElement.target.getBoundingClientRect();
    const parent = document.body.getBoundingClientRect();
    return {
      top: rect.top - parent.top,
      left: rect.left - parent.left,
      width: rect.width,
      height: rect.height,
      transform: 'scale(1) translateY(-35%)',
    };
  }, [activeElement.target]);

  const handleSetActiveElement = (element: IActiveElement) => {
    clearTimeout(timeout.current);
    if (element.target === null) {
      setActiveElement(element);
    } else {
      timeout.current = setTimeout(() => {
        setActiveElement(element);
        clearTimeout(timeout.current);
      }, 350);
    }
  };

  const cancelTimeout = () => {
    clearTimeout(timeout.current);
  };

  return (
    <PreviewContext.Provider
      value={{
        portalRef: portalRef.current,
        activeElement,
        setActiveElement: handleSetActiveElement,
        cancelTimeout,
      }}
    >
      <div className={classes.portal} ref={portalRef} style={getStyles} />
      {props.children}
    </PreviewContext.Provider>
  );
};

PreviewContainerCard.Iddle = PreviewCardIddle;
PreviewContainerCard.Active = PreviewCardActive;
export default PreviewContainerCard;
